import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Box, Container, IconButton, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import logoMain from "../../assets/logoPng.png";

const menuItems = [
  { label: "Home", path: "/", target: false },
  { label: "About Us", path: "/about", target: false },
  { label: "Our Agents", path: "/agents", target: false },
  {
    label: "Find Us On Bayut",
    path: "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238",
    target: true,
  },
  { label: "Contact Us", path: "/contact", target: false },
  { label: "Privacy Policy", path: "/privacy-policy", target: false },
  { label: "Terms & Conditions", path: "/terms-conditions", target: false },
];

export default function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: "var(--color-bg)",
        color: "var(--color-text-primary)",
        pt: { xs: 10, md: 6 },
      }}
    >
      <Container maxWidth="xl">
        {/* MAIN GRID */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "2fr 1fr 1.3fr 1.5fr" },
            gap: { xs: 6, md: 10 },
          }}
        >
          {/* ABOUT */}
          <Box>
            <Box
              component="img"
              src={logoMain}
              alt="Vision X Nexus"
              sx={{ height: 46, mb: 3 }}
            />

            <Typography
              sx={{
                color: "var(--color-text-muted)",
                fontSize: 14,
                lineHeight: 2,
                maxWidth: 380,
              }}
            >
              Vision X Nexus Real Estate L.L.C is a luxury real estate
              consultancy based in the UAE, specializing in residential,
              commercial, and high-return investment properties. We deliver
              trusted advisory, market intelligence, and premium opportunities
              across Sharjah, Dubai, and Ajman.
            </Typography>
          </Box>

          {/* LINKS */}
          <Box>
            <Typography sx={footerTitle}>USEFUL LINKS</Typography>

            {menuItems.map((item) => (
              <Typography key={item.label} sx={{ mb: 1.6 }}>
                <Link
                  component={item.target ? "a" : RouterLink}
                  to={!item.target ? item.path : undefined}
                  href={item.target ? item.path : undefined}
                  target={item.target ? "_blank" : undefined}
                  underline="none"
                  sx={{
                    color: "var(--color-text-muted)",
                    fontSize: 14,
                    transition: "all 0.25s ease",
                    "&:hover": {
                      color: "var(--color-gold)",
                      paddingLeft: "4px",
                    },
                  }}
                >
                  {item.label}
                </Link>
              </Typography>
            ))}
          </Box>

          {/* CONTACT */}
          <Box>
            <Typography sx={footerTitle}>CONTACT DETAILS</Typography>

            <ContactRow
              icon={<PhoneIcon />}
              text="+971 54 791 4848"
              link="tel:+971547914848"
            />
            <ContactRow
              icon={<EmailIcon />}
              text="info@visionxnexus.com"
              link="mailto:info@visionxnexus.com"
            />

            <Box sx={{ display: "flex", gap: 2 }}>
              <LocationOnIcon sx={{ color: "var(--color-gold)" }} />
              <Typography
                sx={{
                  fontSize: 14,
                  lineHeight: 1.8,
                  color: "var(--color-text-muted)",
                }}
              >
                Bell Rashid Towers
                <br />
                Al Majaz 1, Sharjah
                <br />
                United Arab Emirates
              </Typography>
            </Box>
          </Box>

          {/* MAP */}
          <Box
            sx={{
              borderRadius: "20px",
              overflow: "hidden",
              border: "1px solid rgba(207,172,106,0.35)",
              boxShadow: "0 18px 40px rgba(0,0,0,0.12)",
              height:"230px",
            }}
          >
            <iframe
              title="Vision X Nexus Location"
              src="https://www.google.com/maps?q=Vision%20X%20Nexus%20Sharjah&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
            />
          </Box>
        </Box>

        {/* DIVIDER */}
        <Box
          sx={{
            my: 6,
            height: "1px",
            background:
              "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
            opacity: 0.4,
          }}
        />

        {/* BOTTOM BAR */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 3,
            pb: 4,
          }}
        >
          <Typography sx={footerSmall}>
            Designed & Developed by{" "}
            <Link
              href="https://oglitz.com"
              target="_blank"
              underline="none"
              sx={{ color: "var(--color-gold)" }}
            >
              Oglitz Software Pvt Ltd
            </Link>
          </Typography>

          <Typography sx={footerSmall}>
            © {new Date().getFullYear()} Vision X Nexus Real Estate L.L.C. All
            Rights Reserved.
          </Typography>

          {/* SOCIAL */}
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <SocialBtn href="https://www.facebook.com/profile.php?id=61566966280583">
              <FacebookIcon />
            </SocialBtn>
            <SocialBtn href="https://www.instagram.com/visionxnexus_/">
              <InstagramIcon />
            </SocialBtn>
            <SocialBtn href="https://www.youtube.com/@vision-x-nexus">
              <YouTubeIcon />
            </SocialBtn>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

/* ---------------- helpers ---------------- */

const footerTitle = {
  color: "var(--color-gold)",
  fontWeight: 600,
  letterSpacing: "0.18em",
  fontSize: 12,
  mb: 3,
};

const footerSmall = {
  fontSize: 13,
  color: "var(--color-text-muted)",
};

const SocialBtn = ({ href, children }) => (
  <IconButton
    component="a"
    href={href}
    target="_blank"
    sx={{
      width: 40,
      height: 40,
      border: "1px solid rgba(207,172,106,0.4)",
      color: "var(--color-gold)",
      transition: "all 0.25s ease",
      "&:hover": {
        backgroundColor: "var(--color-gold)",
        color: "var(--color-text-primary)",
      },
    }}
  >
    {children}
  </IconButton>
);

const ContactRow = ({ icon, text, link }) => (
  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
    <Box sx={{ color: "var(--color-gold)" }}>{icon}</Box>
    <Link
      href={link}
      underline="none"
      sx={{ fontSize: 14, color: "var(--color-text-primary)" }}
    >
      {text}
    </Link>
  </Box>
);
